(function () {
  const envelopeRegex = /^\+[1-9]\d{1,14}$/;

  function normalizePhone(rawPhone) {
    return String(rawPhone || '').trim().replace(/[^0-9+]/g, '');
  }

  function validateInternationalPhone(input) {
    const normalized = normalizePhone(input);
    if (!envelopeRegex.test(normalized)) {
      return {
        normalized,
        isValid: false,
        reason: 'invalid_envelope',
      };
    }

    const parser = globalThis.libphonenumber?.parsePhoneNumberFromString;
    if (typeof parser !== 'function') {
      console.error('[lead-form-phone-validation] libphonenumber parser is unavailable');
      return {
        normalized,
        isValid: true,
        reason: 'fallback_envelope_only',
      };
    }

    let phoneNumber = null;
    try {
      phoneNumber = parser(normalized);
    } catch (_) {
      phoneNumber = null;
    }

    if (!phoneNumber) {
      return {
        normalized,
        isValid: false,
        reason: 'parse_failed',
      };
    }

    if (!phoneNumber.isPossible()) {
      return {
        normalized,
        isValid: false,
        reason: 'not_possible',
      };
    }

    if (!phoneNumber.isValid()) {
      return {
        normalized,
        isValid: false,
        reason: 'not_valid',
      };
    }

    return {
      normalized,
      isValid: true,
      reason: 'ok',
      country: phoneNumber.country || '',
      e164: phoneNumber.number || normalized,
    };
  }

  globalThis.LeadFormPhoneValidation = Object.freeze({
    envelopeRegex,
    normalizePhone,
    validateInternationalPhone,
  });
})();
